import React from 'react'
import { InfoContainer } from './InfoContainer'
import tw from 'twin.macro'

interface Props {
  isOnline: boolean
}

export const OfflineBanner = ({ isOnline }: Props) => {
  if (isOnline) {
    return null
  }

  return (
    <InfoContainer className={tw`mb-4`} color="error" dataTestId="offline-banner">
      You are offline — please check your internet connection
    </InfoContainer>
  )
}
